import { IChecklist } from '../api/types/checklist'
import IResultSet from '../api/types/resultSet'
import { reportAreaCopies } from './AreaCopies'
import { isFilled } from './answerFilled'

export { isFilled }

export default class ReportUtil {
  // Calculate success rate in percent
  public static calculatePercentage = (displayCount: number, totalCount: number): number => {
    // cut of float numbers
    // we don't use round()
    if (displayCount === 0 || totalCount === 0) {
      return 0
    }

    return Math.round((displayCount / totalCount) * 100.0)
  }

  public static getHiddenQuestionIds = (checklist: IChecklist): number[] => {
    const hiddenQuestionIds = checklist.areas.reduce((a, b) => a.concat(
      b.questions.filter((x) => (x.question_type === 'information' || x.hide || x.exclude_from_progress || x.question_type === 'apicall')
                && x.question_type !== 'start_date')
    ), []).map((x) => x.id)

    const questionsIdsInHiddenAreas = checklist.areas.filter(
      (x) => x.hide && x.questions.length
    ).map((area) => area.questions.map((question) => question.id)[0])

    return [...hiddenQuestionIds, ...questionsIdsInHiddenAreas]
  }

  // the header of the report ("x von y Fragen"), counted as it always was
  public static getFilledQuestionCount = (checklist: IChecklist, resultSet: IResultSet): number => {
    const questionCount = ReportUtil.getQuestionCount(checklist, resultSet)
    const hiddenQuestionIds = ReportUtil.getHiddenQuestionIds(checklist)

    const count = resultSet.results
      ? resultSet.results.filter((r) => isFilled(r, resultSet)
            && !hiddenQuestionIds.includes(r.question_id)).length
      : 0
    return count < questionCount ? count : questionCount
  }

  public static getQuestionCount = (checklist: IChecklist, resultSet: IResultSet): number => {
    const hiddenQuestionIds = ReportUtil.getHiddenQuestionIds(checklist)

    // every copy of an area once (copies made by hand included), see reportAreaCopies
    const questions = reportAreaCopies(checklist.areas, resultSet).flatMap((x) => x.questions)
      .filter((x) => !hiddenQuestionIds.includes(x.id))

    let count = 0

    for (const question of questions) {
      count += question.show_count ?? 1
    }

    return count
  }
}
